import React, { Context, useContext } from "react";
import { ISelectState, SelectContext } from "./Select";

interface ISelectStore {
  state: ISelectState;
  updateState: (newState: Partial<ISelectState>) => void;
  blurInput: () => void;
}

interface ISelectActionProps {
  className?: string;
  onClick: () => void;
  children: React.ReactNode;
}

/** Dropdown row that closes the menu before running its action. */
export default function SelectAction(props: ISelectActionProps) {
  const selectStore = useContext<ISelectStore>(SelectContext as Context<ISelectStore>);

  return (
    <div
      className={props.className}
      onClick={event => {
        event.stopPropagation();
        selectStore?.updateState({ dropdownVisible: false, focus: false });
        selectStore?.blurInput();
        props.onClick();
      }}
    >
      {props.children}
    </div>
  );
}
